<template>
    <div class="banner-wrapper">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in banners" :key="index">
                    <img class="banner" :src="item" alt="" />
                </div>
            </div>
            
        </div>
        <div class="content">
            <img :src="require('@/assets/ooeli.png')" alt="" class="ooeli-logo" />
            <img :src="require('@/assets/phone.png')" alt="" class="phone" />
            <div class="body">
                <div class="logo-wrap">
                    <img :src="require('@/assets/logo.png')" alt="" class="logo" />
                    <div class="logo-body">
                        <h1>目里</h1>
                        <h2>这里有你想要的美好生活</h2>
                    </div>
                </div>
                <div class="download-lists">
                    <div class="download-list" v-for="item in lists" :key="item.text">
                        <img class="icon" :src="item.icon" alt="" />
                        <div class="name">{{ item.text }}</div>
                        <div class="download-qrcode">
                            <img :src="item.qrcode" alt="" class="qrcode" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banner-mask"></div>
    </div>
</template>

<script>
import { onMounted } from "vue";
import Banner1 from "@/assets/banner1.jpg";
import Banner2 from "@/assets/banner2.jpg";
import Banner3 from "@/assets/banner3.jpg";
import Banner4 from "@/assets/banner4.jpg";
export default {
    components: {},
    setup() {
        onMounted(() => {
            new Swiper(".swiper", {
                effect: "fade",
                autoplay: {
                    delay: 3000, // 自动切换的时间间隔，单位ms
                },
            });
        });
        return {
            banners: [Banner1, Banner2, Banner3, Banner4],
            lists: [
                { icon: require("@/assets/ios.png"), text: "App Store", qrcode: require("@/assets/apple-qrcode.png") },
                { icon: require("@/assets/android.png"), text: "Android", qrcode: require("@/assets/android-qrcode.png") },
                { icon: require("@/assets/wechat.png"), text: "目里小程序", qrcode: require("@/assets/wechat-qrcode.jpg") },
            ],
        };
    },
};
</script>

<style lang="less" scoped>
.banner-wrapper {
    height: 100vh;
    position: relative;
    .swiper,
    .swiper-wrapper,
    .banner {
        width: 100%;
        height: 100%;
    }
    .content {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        .ooeli-logo {
            position: absolute;
            top: 17px;
            left: 24px;
            width: 90px;
            height: 30px;
        }
        .phone {
            max-width: 313px;
            max-height: 645px;
            width: 21.7vw;
            height: 44.8vw;
        }
        .body {
            margin-left: 85px;
            .logo-wrap {
                display: flex;
                align-items: center;
                .logo {
                    width: 88px;
                    height: 88px;
                    margin-right: 16px;
                }
                .logo-body {
                    h1 {
                        height: 53px;
                        font-size: 38px;
                        font-weight: 600;
                        color: rgba(255, 255, 255, 0.949999988079071);
                        line-height: 45px;
                    }
                    h2 {
                        height: 32px;
                        font-size: 23px;
                        color: rgba(255, 255, 255, 0.949999988079071);
                        line-height: 27px;
                        margin-top: 4px;
                        font-weight: 400;
                    }
                }
            }
            .download-lists {
                display: flex;
                margin-top: 32px;
                .download-list {
                    width: 148px;
                    height: 56px;
                    background: #232428;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    position: relative;
                    .icon {
                        width: 24px;
                        height: 24px;
                        margin-right: 8px;
                    }
                    .name {
                        height: 19px;
                        font-size: 16px;
                        font-weight: 500;
                        color: rgba(255, 255, 255, 0.949999988079071);
                        line-height: 19px;
                    }
                    + .download-list {
                        margin-left: 16px;
                    }
                    &:hover {
                        .download-qrcode {
                            display: block;
                        }
                    }
                    .download-qrcode {
                        position: absolute;
                        top: 56px;
                        left: 0;
                        background-color: #232428;
                        width: 148px;
                        height: 136px;
                        text-align: center;
                        display: none;
                        .qrcode {
                            display: block;
                            margin: 0 auto;
                            width: 124px;
                            height: 123px;
                        }
                    }
                }
            }
        }
    }
}

.banner-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.1);
    width: 100%;
    height: 100%;
    z-index: 1;
}
</style>
